import { useHistory } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { usePortal_GetPortalDocumentsStatsByIdQuery } from 'queries';

import { NotificationSeverity, showAlert } from 'utils/notification-manager';

import { DocumentsStatsCard } from './documents-stats-card/documents-stats-card';
import { useStyles } from './portal-documents-stats.styles';

type PortalDocumentsForSignatureProps = {
  portalId: string;
};

export const PortalDocumentsForSignature = ({ portalId }: PortalDocumentsForSignatureProps) => {
  const history = useHistory();
  const classes = useStyles();

  const { data: portalDocumentsStatsData } = usePortal_GetPortalDocumentsStatsByIdQuery({
    variables: {
      portalId,
    },
    onError: (e) => {
      showAlert({
        message: 'Error getting Portal task stats: ' + e.message,
        severity: NotificationSeverity.ERROR,
      });
    },
  });

  const portalDocumentsStats = portalDocumentsStatsData?.data;

  if (
    !portalDocumentsStats ||
    (!portalDocumentsStats.documentsForReviewCount && !portalDocumentsStats.generatedDocumentsCount)
  ) {
    return null;
  }

  const onViewAssignedTasks = () => {
    history.push(`/home/${portalId}/assigned-tasks`);
  };

  return (
    <Box className={classes.container}>
      <Box className={classes.headerContainer}>
        <Typography className={classes.headerText}>Documents for Signature:</Typography>
      </Box>

      <Box className={classes.statsContainer}>
        {portalDocumentsStats.documentsForReviewCount > 0 && (
          <DocumentsStatsCard
            onClick={onViewAssignedTasks}
            title="Documents for Review/Signature"
            value={portalDocumentsStats.documentsForReviewCount}
          />
        )}
        {portalDocumentsStats.generatedDocumentsCount > 0 && (
          <DocumentsStatsCard
            onClick={onViewAssignedTasks}
            title="Generated Documents"
            value={portalDocumentsStats.generatedDocumentsCount}
          />
        )}
      </Box>
    </Box>
  );
};
